import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async patch() {
    const field = this.element.dataset.field
    const body = new URLSearchParams({ [`booking[${field}]`]: this.element.value })
    const csrf = document.querySelector("meta[name='csrf-token']")

    try {
      const response = await fetch(this.element.dataset.url, {
        method: "PATCH",
        headers: { "X-CSRF-Token": csrf ? csrf.content : "" },
        body
      })
      if (!response.ok) console.log('error while patching')
    } catch (error) {
      console.log('error while patching')
    }
  }

}
